import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CwMsalService } from './../../services/cw-msal.service';
import { XWareLogService } from '../../services/xware-log.service';

@Component({
  selector: 'xware-loginredirect',
  templateUrl: './loginredirect.component.html',
  styleUrls: ['./loginredirect.component.scss'],
})
export class LoginRedirectComponent implements OnInit, OnDestroy {
  logout = false;
  private logoutResetInterval: ReturnType<typeof setInterval> | null = null;

  constructor(
    private cwMsalService: CwMsalService,
    private route: ActivatedRoute,
    private logger: XWareLogService
  ) {
    if (this.route.snapshot.queryParams['logout']) {
      this.logger.log('LoginRedirect: logout true');
      this.logout = true;
      this.logoutResetInterval = setInterval(() => {
        this.logout = false;
      }, 1500);
    }
  }

  ngOnInit() {
    localStorage.removeItem('AUId');
    sessionStorage.removeItem('AUId');
    const strTempInitVars = sessionStorage.getItem('initParams');
    sessionStorage.clear();
    sessionStorage.setItem('portalURL', environment.portalapiurl);
    sessionStorage.setItem('initParams', strTempInitVars ?? '');
    if (!this.logout) {
      sessionStorage.setItem('adType', 'msal');
      this.cwMsalService.handleRedirect();
    }
  }

  ngOnDestroy(): void {
    if (this.logoutResetInterval) {
      clearInterval(this.logoutResetInterval);
      this.logoutResetInterval = null;
    }
  }
}
